/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { IconButton } from "@mui/material";
import {
    IconColumnsOff,
    IconColumns2,
    IconColumns3,
} from "@tabler/icons-react";
import { useCurrentEditor } from "@tiptap/react";
import { ButtonTooltip } from "./toolbar-button/button-tooltip";

const AddColumnsButton = () => {
    
    const { editor } = useCurrentEditor();
    const editorIsActive = editor.isActive("columnBlock");
    const toolTipText = editorIsActive ? "Remove Columns" : "Add 2 Columns";
    
    function onClick3Col () {
        editor.chain().focus().setColumns(3).run();
    }
    function onClick2Col () {
        if (editorIsActive) {
            editor.chain().focus().unsetColumns().run();
        } else {
            editor.chain().focus().setColumns(2).run();
        }
    }
    // function onClickOff() {
    //     editor.chain().focus().unsetColumns().run()
    // }
    // const setQuantityAmount = (event) => {
    //     const qty = event.target.value
    //     setQuantity(qty)
    // }
    
    return (
        <>
            <ButtonTooltip title={toolTipText}>
                <IconButton onClick={onClick2Col}>
                    {!editorIsActive &&
                        <IconColumns2 />
                    }
                    {editorIsActive &&
                        <IconColumnsOff />
                    }
                </IconButton>
            </ButtonTooltip>
            {!editorIsActive &&
                <ButtonTooltip title={"Add 3 Columns"}>
                    <IconButton onClick={onClick3Col}>
                        <IconColumns3 />
                    </IconButton>
                </ButtonTooltip>
            }
            {/*<Select*/}
            {/*    className='toolbar-seelct'*/}
            {/*    labelId='quantity'*/}
            {/*    id='quantity'*/}
            {/*    value={quantity}*/}
            {/*    variant='outlined'*/}
            {/*    onChange={(event) => setQuantityAmount(event)}*/}
            {/*>*/}
            {/*    <MenuItem value='2'>2</MenuItem>*/}
            {/*    <MenuItem value='3'>3</MenuItem>*/}
            {/*    <MenuItem value='4'>4</MenuItem>*/}
            {/*</Select>*/}
        </>
    );
};

export { AddColumnsButton };
